import { __export } from "../../../../../../_virtual/rolldown_runtime.js";

//#region src/framework/utils/constants.ts
var constants_exports = /* @__PURE__ */ __export({ unicode: () => unicode });
const unicode = {
	BULLET: "•",
	COPYRIGHT: "©",
	DAGGER: "†",
	DEGREE_C: "℃",
	DEGREE_F: "℉",
	DOUBLE_DAGGER: "‡",
	REGISTERED: "®",
	SECTION: "§",
	TRADEMARK: "™"
};

//#endregion
export { constants_exports };